import classNames from "classnames";
import { Button } from "primereact/button";
import { ChangeEvent, SyntheticEvent, useRef, useState } from "react";
import ImageViewer from "../image-viewer/image-viewer";

export const evaluateUrlImageIsPreviewable = (
  specimen: string | File | undefined
) => {
  if (typeof specimen === "string") {
    return true;
  }

  return false;
};

export interface FormImageProps {
  urlImage?: string | File;
  label?: string;
  disabled?: boolean;
  imagePreviewClass?: string;
  onImageChange?: (image: File | undefined) => void;
}

export function ImageField({
  label,
  urlImage,
  disabled,
  imagePreviewClass = "w-10rem h-10rem",
  onImageChange,
}: FormImageProps) {
  const [imageFilePreview, setImageFilePreview] = useState<
    string | File | undefined
  >(urlImage);
  const [onDemandUpload, setOnDemandUpload] = useState(false);
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleImageChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (!event.target.files || event.target.files.length === 0) return;

    const image = event?.target?.files[0];
    setImageFilePreview(image);

    if (onImageChange) {
      onImageChange(image);
    }
  };

  const uploadMode = (event: SyntheticEvent) => {
    event.preventDefault();
    setOnDemandUpload(true);
  };

  const handleRemoveImage = (event: SyntheticEvent) => {
    if (fileInputRef.current) {
      setImageFilePreview(undefined);
      fileInputRef.current.value = "";
    }

    if (onImageChange) {
      onImageChange(undefined);
    }
  };

  const imageInput = (
    <span id="image-input">
      {imageFilePreview && (
        <ImageViewer
          className={classNames("w-40 h-40")}
          image={imageFilePreview}
        />
      )}
      <input
        type="file"
        ref={fileInputRef}
        onChange={handleImageChange}
        disabled={disabled}
        className="my-2"
      />
      {imageFilePreview && (
        <div>
          <Button
            label="Remove Photo"
            onClick={handleRemoveImage}
            severity="secondary"
            outlined
          />
        </div>
      )}
    </span>
  );
  const imagePreview = (
    <span id="image-preview">
      <img
        src={urlImage as string}
        alt={urlImage as string}
        className={imagePreviewClass}
      />
      <div className="mt-2 flex gap-2">
        <Button onClick={uploadMode} size="small" disabled={disabled} outlined>
          Change
        </Button>
        <Button
          onClick={(e) => {
            e.preventDefault();
            window.open(urlImage as string);
          }}
          size="small"
          disabled={disabled}
          severity="secondary"
          outlined
        >
          View
        </Button>
      </div>
    </span>
  );
  const display = () => {
    if (evaluateUrlImageIsPreviewable(urlImage) && !onDemandUpload) {
      return imagePreview;
    }

    return imageInput;
  };

  return (
    <div>
      {label && <label className="text-gray-500 mb-2">{label}</label>}
      <div>{display()}</div>
    </div>
  );
}

export default ImageField;
